import PropTypes from 'prop-types';
import React from 'react';
import ClassNames from 'classnames';
import './index.scss';

class BookingGone extends React.PureComponent {
  static displayName = 'BookingGone-AnyGuide';

  static propTypes = {
    icon_name: PropTypes.string.isRequired,
    icon_color: PropTypes.string.isRequired,
    lead: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    dashboard_link_text: PropTypes.string.isRequired,
    dashboard_link_path: PropTypes.string.isRequired,
  };

  render() {
    const iconClasses = ClassNames(
      'icon',
      this.props.icon_color,
      this.props.icon_name
    );

    return (
      <div className="GoneContainer">
        <div className="IconContainer">
          <i className={iconClasses} />
        </div>
        <p className="lead">{this.props.lead}</p>
        <p
          className="message"
          dangerouslySetInnerHTML={{ __html: this.props.message }}
        />
        <p className="link">
          <a href={this.props.dashboard_link_path}>
            {this.props.dashboard_link_text}
            <span className="icon af-arrow-right" />
          </a>
        </p>
      </div>
    );
  }
}

export default BookingGone;
